import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MarkdownComponent } from 'ngx-markdown';

@Component({
  selector: 'app-cp-tabs',
  imports: [MatTabsModule, MarkdownComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="app-mat-mdc-tab-group">
      <mat-tab label="First">
        <markdown clipboard class="variable-binding" [data]="markdown" />
      </mat-tab>
      <mat-tab label="Second">Content 2</mat-tab>
      <mat-tab label="Third">Content 3</mat-tab>
    </mat-tab-group>
  `,
  styles: ``,
})
export class CpTabsComponent {
  markdown = `
<h2 class="Headline-5 mt-0 mb-10">Link Account</h2>

<h4 class="Subtitle-3 mt-0">API Overview</h4>
<p class="Body-3 mt-0 mb-xxl text-high-gray-60">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
    Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
    Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. 
    This API allows users to link their accounts securely by interacting with the provided endpoints. 
    The overview section provides essential details about the API’s functionality and its potential use cases. 
    Understanding the basic principles behind account linking is crucial for developers when integrating this API into their systems.
</p>

<h4 class="Subtitle-3 my-2">Request</h4>
<p class="Body-3 mt-0 mb-xxl text-high-gray-60">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
    Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
    Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. 
    This section describes the structure and format of the API request. 
    It covers the necessary parameters, headers, and other configurations that should be included in the API call. 
    Understanding the request structure is essential for ensuring that data is submitted correctly to the server.
</p>

\`\`\`python
import json
import random

def generate_dummy_data():
    data = {
        "user_id": random.randint(1, 100),
        "name": f"User{random.randint(1, 100)}",
        "email": f"user{random.randint(1, 100)}@example.com",
        "age": random.randint(18, 60),
        "is_active": random.choice([True, False]),
        "created_at": "2025-01-21T12:00:00",
        "items": [
            {"item_id": random.randint(1, 1000), "item_name": f"Item{random.randint(1, 100)}", "quantity": random.randint(1, 5)}
            for _ in range(random.randint(1, 5))
        ]
    }
    return json.dumps(data, indent=4)

# Generate and print dummy JSON
dummy_json = generate_dummy_data()
print(dummy_json)
\`\`\`

<h4 class="Subtitle-3 mt-5 mb-2">Response</h4>
<p class="Body-3 mt-0 mb-xxl text-high-gray-60">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
    Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
    Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. 
    This section explains the structure of the response that the API will return after successfully processing the request. 
    The response includes key details such as user data, items associated with the user, and their respective quantities. 
    It is important to verify the response to ensure that all information matches the expected format.
</p>

\`\`\`json
{
    "user_id": 23,
    "name": "User57",
    "email": "user57@example.com",
    "age": 34,
    "is_active": true,
    "created_at": "2025-01-21T12:00:00",
    "items": [
        {
            "item_id": 495,
            "item_name": "Item76",
            "quantity": 3
        },
        {
            "item_id": 860,
            "item_name": "Item12",
            "quantity": 2
        }
    ]
}
\`\`\`
`;
}
